import { Directive, ElementRef, HostListener, Inject, Input } from "@angular/core";
import { SessionHandlerService, SessionHandlerServiceToken } from "@feature_core/session/session.module";

@Directive({
  selector: "[sessionReviveInput]"
})
export class SessionReviveInputDirective {

  @Input("sessionReviveInput") triggerFrom: number;
  private keyUpCount = 0;
  private keyCodeBlackList = [9, 13, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 44, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 144, 145, 255];

  @HostListener("keyup", ["$event"]) onKeyUp(event) {
    if (event) {
        if (this.keyCodeBlackList.indexOf(event.which || event.keyCode || 255) < 0) {
            ++this.keyUpCount;
        }
    }
    if (this.triggerFrom && this.divisible()) {
      this.doRevive();
    }
  }

  @HostListener("blur") onBlur() {
    if (!this.triggerFrom) {
      this.doRevive();
    }
  }

  get elementValue(): number {
    return this.elRef.nativeElement.value.length;
  }

  constructor(
    private elRef: ElementRef,
    @Inject(SessionHandlerServiceToken)
    protected _sessionHandler: SessionHandlerService
  ) {
  }

  private divisible(): boolean {
    return this.elementValue > 0 && this.keyUpCount >= this.triggerFrom;
  }

  private doRevive() {
    this.keyUpCount = 0;
    this._sessionHandler.reviveSession();
  }
}
